import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Helper padrao do shadcn/ui: junta classes condicionais (clsx) e resolve
 * conflitos de utilitarios Tailwind mantendo a ultima (tailwind-merge).
 *
 * Ex.: cn('p-2 text-sm', isAtivo && 'text-primary', className)
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
